import React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  EmployeesEmployeeNameQuickViewFragment,
  PerformanceV2InlineEmployeeNameFragment,
} from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeQuickView } from 'modules/employees/components/EmployeeQuickView'

interface InlineEmployeeProps {
  employee: PerformanceV2InlineEmployeeNameFragment
  hideAvatar?: boolean
}

interface QuickViewProps {
  employee?: EmployeesEmployeeNameQuickViewFragment | null
  children: React.ReactNode
}

const QuickView: React.FC<QuickViewProps> = ({ employee, children }) => {
  if (!employee) return <>{children}</>
  return <EmployeeQuickView employee={employee}>{children}</EmployeeQuickView>
}

export const InlineEmployee: React.FC<InlineEmployeeProps> = ({ employee, hideAvatar }) => {
  return (
    <QuickView employee={employee}>
      <Box inline>
        <Box gap="s8" flexDirection="row" alignItems="center">
          {!hideAvatar && (
            <Avatar
              label={employee.fullName}
              url={employee.avatar?.url && buildUrl(employee.avatar.url)}
              size="s32"
            />
          )}
          <Text.Normal size="300" whiteSpace="nowrap" ellipsis title={null}>
            {employee.fullName}
          </Text.Normal>
        </Box>
      </Box>
    </QuickView>
  )
}
